import { visitorHeaders } from './visitorId';

export type VisitCounters = {
  online: number;
  today_visitors: number;
  today_pageviews: number;
  yesterday_visitors: number;
  total_visitors: number;
};

export function renderVisitCounters(data: VisitCounters): void {
  const online = document.getElementById('stat-online');
  const today = document.getElementById('stat-today');
  const views = document.getElementById('stat-views');
  const total = document.getElementById('stat-total');
  if (online) online.textContent = String(data.online);
  if (today) today.textContent = String(data.today_visitors);
  if (views) views.textContent = String(data.today_pageviews);
  if (total) total.textContent = String(data.total_visitors);
}

async function fetchCounters(): Promise<VisitCounters | null> {
  try {
    const r = await fetch('/api/visitcounters', { credentials: 'same-origin', headers: visitorHeaders() });
    if (!r.ok) return null;
    return (await r.json()) as VisitCounters;
  } catch {
    return null;
  }
}

async function pingVisit(): Promise<VisitCounters | null> {
  try {
    const r = await fetch('/api/visitping', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', ...visitorHeaders() },
      body: '{}',
    });
    if (!r.ok) return null;
    return (await r.json()) as VisitCounters;
  } catch {
    return null;
  }
}

export function initVisitCounters(): void {
  if (!document.getElementById('site-stats')) {
    return;
  }

  const refresh = async (usePing: boolean): Promise<void> => {
    const data = usePing ? await pingVisit() : await fetchCounters();
    if (data) {
      renderVisitCounters(data);
    }
  };

  void refresh(false);
  window.setInterval(() => void refresh(false), 60_000);
  window.setInterval(() => void refresh(true), 5 * 60_000);
}
